import { render } from "./FormInputRadio.vue?vue&type=template&id=38047961&lang=pug"
import script from "./FormInputRadio.vue?vue&type=script&lang=js"
export * from "./FormInputRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__